import { range } from 'lodash';
import { isChordTuplet } from '../sheet';
import { sheetResolution } from './sheetToGrid';
export function generateMetronomeSheet(sheet, ticks, tickNote) {
    const resolution = tickNote ?? sheetResolution(sheet);
    return {
        segments: sheet.segments.map(generateMetronomeSegment(resolution, ticks))
    };
}
function generateMetronomeSegment(tickNote, ticks) {
    return (segment) => ({
        ...segment,
        measures: segment.measures.map(generateMetronomeMeasure(segment.signature, tickNote, ticks))
    });
}
export function generateStickingMetronomeSheet(sheet, ticks) {
    const tickNote = sheetResolution(sheet);
    return { segments: sheet.segments.map(generateStickingMetronomeSegment(tickNote, ticks)) };
}
function generateStickingMetronomeSegment(tickNote, ticks) {
    return (segment) => {
        const isEmpty = segment.measures.every(measure => measure.notes.every(c => isChordTuplet(c)
            ? c.chords.every(n => n.length == 0)
            : c.notes.length == 0));
        if (isEmpty) {
            return {
                ...segment,
                measures: segment.measures.map(generateMetronomeMeasure(segment.signature, tickNote, ticks))
            };
        }
        return {
            ...segment,
            measures: segment.measures.map(generateStickingMetronomeMeasure(segment.signature))
        };
    };
}
function generateMetronomeMeasure(signature, tickNote, ticks) {
    return () => {
        const { denominator } = signature;
        const notes = range(0, tickNote).map((tick) => {
            const isBeatFirst = tick % (tickNote / denominator) == 0;
            const isFirst = tick == 0;
            return ({
                duration: [1, tickNote],
                notes: isFirst
                    ? [{ pitch: 75, dynamics: 'accent' }]
                    : isBeatFirst
                        ? [{ pitch: 76 }]
                        : ticks ? [{ pitch: 76, dynamics: 'ghost' }] : []
            });
        });
        return { notes };
    };
}
function generateStickingTick(notes) {
    if (notes.filter(n => n.sticking != null).length > 1) {
        throw new Error(`Multiple sticking notes in chord ${notes}`);
    }
    return notes.filter(n => n.sticking != null)
        .map(n => ({ ...n, pitch: n.sticking == 'R' ? 67 : 68 }));
}
function generateStickingNotes(chord) {
    if (isChordTuplet(chord)) {
        return { ...chord, chords: chord.chords.map(generateStickingTick) };
    }
    else {
        return { ...chord, notes: generateStickingTick(chord.notes) };
    }
}
function generateStickingMetronomeMeasure(signature) {
    return (measure) => ({
        ...measure,
        notes: measure.notes.map(generateStickingNotes)
    });
}
//# sourceMappingURL=metronomeSheet.js.map